import img2 from '../../assets/img/light sofa.jpg';
import img3 from '../../assets/img/reading table.jpg';
import img4 from '../../assets/img/office chair.jpg';

const aboutData = {
    aboutData:[
        {
            id: 1,
            img: img2,
            title: "house sofa",
            text: "Don’t give up funtionality for great looks, these products have it all"
        },
        {
            id: 2,
            img: img3,
            title: "working table",
            text: "Don’t give up funtionality for great looks, these products have it all"
        },
        {
            id: 3,
            img: img4,
            title: "office chair",
            text: "Don’t give up funtionality for great looks, these products have it all"
        },
    ]
}  
export default aboutData
